export const ADD_COORDINATES = 'ADD_COORDINATES';
export const REORDER_COORDINATES = 'REORDER_COORDINATES';
export const DELETE_COORDINATES = 'DELETE_COORDINATES';
